import React, { useContext } from 'react';
import { SelectValueViewer } from 'components';
import { getObjectValue } from 'utilities';
import getOptionsAccordingApproach from './getOptionsAccordingApproach';
import { MultipleTypeApproachProps } from './types';
import DCFTVTContext from '../../context/DCFTVTContext';

const MultipleTypeApproachValueViewer = (props: MultipleTypeApproachProps) => {
  const { cell, dcfWacc } = getObjectValue(props);
  const { revenueMultipleOptions, ebitdaMultipleOptions } = useContext(DCFTVTContext);
  const options = getOptionsAccordingApproach({
    dcfWacc,
    cell,
    revenueMultipleOptions: revenueMultipleOptions as string[],
    ebitdaMultipleOptions: ebitdaMultipleOptions as string[],
  });

  /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
  /* @ts-ignore: ScalarSpreadsheet is not typed */
  return <SelectValueViewer options={options} {...props} />;
};

export default MultipleTypeApproachValueViewer;
